import { useNavigate } from 'react-router'

import B2becTable from '@/components/B2becTable'
import useDummyItems from '@/hooks/useDummyItems'
import { linkGenerator } from '@/libs/utils/language'

import tableColumns from './TableColumns'

const dataSource = []

const ProductCardTable = ({ dataSrc = dataSource, isLoading = false }) => {
  const navigate = useNavigate()
  const shapeOfProduct = {
    imgUrl: '',
    name: '',
    orderDate: '',
  }

  const fakeItems = useDummyItems(6, shapeOfProduct)
  const handleCellClick = (materialNumber) => {
    return navigate(linkGenerator(`/product/${materialNumber}`))
  }

  const matchingProductClick = (materialNumber) => {
    return navigate(linkGenerator(`/product/${materialNumber}/all`))
  }

  return (
    <B2becTable
      className="order-details-cart-table"
      columns={tableColumns(matchingProductClick, handleCellClick, isLoading)}
      dataSource={isLoading ? fakeItems : dataSrc}
      rowKey={isLoading ? 'materialNumber' : 'key'}
      style={{ marginTop: 20 }}
    />
  )
}

export default ProductCardTable
